exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".square[data-v-f592f9c4]{margin:0 5px 0 0;width:15px;height:15px}", ""]);

// exports
